import { createStore } from 'redux';

const initialState = {
  theme: 'light'
};

function rootReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}

const store = createStore(rootReducer);

export default store;
